// removed by extract-text-webpack-plugin
module.exports = {"default":"xmI8D","xl":"_9MDSq","full":"_1-kDM","l":"i8moW","m":"Wh3A8","s":"_3gLb5","square":"Fgeow","normal":"rhtSb","wide":"_25Aap","cinema":"_1TJzl","xlcinema":"_5X0u_","imax":"IZleT","imaxfull":"_1w7tR","balk":"_3uqyk","smalis":"PN8XQ","lwide":"_18ech","xlwide":"_1mMtQ","portrait":"_3oqGL"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Page/PageComponents/Bild/Bild.scss
 ** module id = 438
 ** module chunks = 0
 **/